"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRiderLocation = void 0;
var superstruct_1 = require("superstruct");
var isStruct_1 = require("../utils/isStruct");
var Timestamp_1 = require("./Timestamp");
var RiderLocationStruct = (0, superstruct_1.type)({
    riderId: (0, superstruct_1.string)(),
    riderName: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    riderStatus: (0, superstruct_1.string)(),
    latitude: (0, superstruct_1.number)(),
    longitude: (0, superstruct_1.number)(),
    warehouseId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    taskId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    updatedAt: Timestamp_1.TimestampStruct,
    externalOrderId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    externalOrderNumber: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    estimatedArrivalAtStoreAt: (0, superstruct_1.optional)(Timestamp_1.TimestampStruct),
});
function isRiderLocation(obj) {
    return (0, isStruct_1.isStruct)(obj, RiderLocationStruct, "RiderLocation");
}
exports.isRiderLocation = isRiderLocation;
